const queryDefault: any = {
    refetchOnWindowFocus: false,
    refetchInterval: false
}

export default queryDefault;
